import { useContext } from 'react';
import { UserContext } from '../../contexts/user-context';
import { useVenturesContext } from '../../contexts/ventures-context';
import { ModalV2 } from '../common';
import AssignVenturesForm from '../forms/assign-ventures';

function MentorAssignmentModal() {
  const { hasAccessToAction } = useContext(UserContext);
  const {
    mentorsAssignmentTargetVenture,
    isMentorsAssigningVenture,
    loadedMentorsById,
    handleMentorsLoaded,
    assignMentorsSuccessForm,
    setMentorsAssignmentTargetVenture,
  } = useVenturesContext();

  const handleClose = () => {
    setMentorsAssignmentTargetVenture(null);
  };

  return hasAccessToAction('venture.details.update') &&
    mentorsAssignmentTargetVenture ? (
    <ModalV2
      open={!!mentorsAssignmentTargetVenture}
      onClose={handleClose}
      titleProps={{
        title: 'New assignment',
        caption: `${mentorsAssignmentTargetVenture.ventureName}`,
      }}
      width='720px'>
      <AssignVenturesForm
        ventureId={mentorsAssignmentTargetVenture.id}
        loading={isMentorsAssigningVenture[mentorsAssignmentTargetVenture.id]}
        onLoaded={handleMentorsLoaded(mentorsAssignmentTargetVenture.id)}
        mentors={loadedMentorsById[mentorsAssignmentTargetVenture.id]}
        onSuccess={assignMentorsSuccessForm(
          mentorsAssignmentTargetVenture.id,
          handleClose,
        )}
        onCancel={handleClose}
      />
    </ModalV2>
  ) : null;
}

export default MentorAssignmentModal;
